import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: auto;
    padding: 0 0 64px;

    gap: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const Wrapper = styled.div`
    width: 100%;
    height: auto;
    max-width: 1000px;
    padding: 16px;

    gap: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const ContainerAcordionCard = styled.div`
    width: 100%;
    height: auto;
    max-width: 400px;
    padding: 16px 0 0;

    gap: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const ContainerModal = styled.div`
    width: 100%;
    height: auto;
    max-width: 480px;
    padding: 16px 0 0;

    gap: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;

    >ul>li{
        text-align: left;
    }
`;

export const ContainerLoading = styled.div`
    width: 100%;
    height: 400px;

    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ContainerRelationOptions = styled.div`
  width: 100%;
  height: auto;
  padding: 42px 170px 16px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin-top: 3px;
  overflow-y: scroll;

  >div{
    width: 100%;
    max-width: 400px;
  }

  @media only screen and (max-width: 990px) {
    padding-right: 120px;
    padding-left: 120px;
  }
  

  @media only screen and (max-width: 780px) {
    padding-right: 15%;
    padding-left: 15%;
  }
  
  @media only screen and (max-width: 479px) {
    padding-right: 5%;
    padding-left: 5%;
  }
  
  @media only screen and (max-width: 380px) {
    padding-right: 5px;
    padding-left: 5px;
  }

  /* width */
  ::-webkit-scrollbar {
  width: 6px;

  
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
  border-radius: 8px;
  
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
`;

export const ContainerToggleGlobal = styled.div`
    width: 100%;
    max-width: 1000px;
    padding: 12px 16px;

    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ContainerToggleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 0 4px;
`;

export const ToggleLabel = styled.span`
    font-size: ${({ small }) => (small ? '11px' : '14px')};
    font-weight: ${({ small }) => (small ? '400' : '600')};
    color: #555;
    white-space: nowrap;
`;

export const Loading = styled.div`

  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }


  width: 80px;
  height: 80px;
  position: relative;

  background-color: transparent;
  border-top: 1px solid #2fbb69;
  border-bottom: 1px solid #2fbb69;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;

`;